import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';

import { getIdentity } from '@sxm-de/dev-kits/web-sdk/domains/identity';

export type HasPhoneNumberFn = () => Promise<boolean>;

export function initHasPhoneNumberFn({
    dependencies,
}: DomainInitPayload): HasPhoneNumberFn {
    return async () => {
        try {
            const identity = await getIdentity(dependencies);
            const hasPhoneNumber = Boolean(identity.contact?.phoneNumber);
            return hasPhoneNumber;
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
